import { isRejected, Middleware, MiddlewareAPI } from '@reduxjs/toolkit';

export const rtkQueryErrorLogger: Middleware =
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (_: MiddlewareAPI) => (next) => (action) => {
    // isRejectedWithValue Or isRejected
    if (isRejected(action)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((action as any).payload?.status === 401) {
        console.log('error auth');
        // window.location.href = '/error';
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((action as any).payload?.status === 403) {
        console.log('forbidden');
        window.location.href = '/forbidden-country';
      }
    }

    return next(action);
  };
